/* unplugin-vue-components disabled */import script from "./RequestForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./RequestForm.vue?vue&type=script&lang=ts&setup=true"

import "./RequestForm.vue?vue&type=style&index=0&id=af6ec9ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af6ec9ea"]])

export default __exports__